import "jspdf-autotable";
import { createI18n } from "vue-i18n";
import { AccountController } from "@/app/ui/controllers/AccountController";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { 
  FailedDispatchPDFProps, 
  PDFComponentProps, 
  TableComponentProps,
  DispatchSttFailedProps 
} from "./types/pdf-types";
import {
  drawHeader,
  drawInfoColumns,
  drawLogo,
} from "./components/pdf-components";
import { drawTable } from "./components/table-components";

const getScanStatusText = (status: string, lastStatus?: string): string => {
  switch (status) {
    case "failed_unpaid":
      return "Belum bayar";
    case "failed_destination":
      return "Kota tujuan tidak sesuai";
    case `failed_${lastStatus}`:
      return `Status tidak sesuai (${lastStatus})`;
    default:
      return `Status tidak sesuai (${lastStatus})`;
  }
};

const failedDispatchPDF = (props: FailedDispatchPDFProps) => {
  const { doc, dataHead, data, logo } = props;

  const i18n = createI18n({
    legacy: false,
    locale: AccountController.accountData.account_type_detail.countryCode.toLowerCase(),
    fallbackLocale: "id",
    globalInjection: false,
    messages: { en, id, my },
  });

  const pdfComponents = new PDFComponentProps({
    doc,
    translate: i18n.global.t,
  });
  const tableComponents = new TableComponentProps({
    doc,
    data,
    dataLength: data.length,
    translate: i18n.global.t,
  });

  drawLogo(pdfComponents, logo);
  drawHeader(pdfComponents);
  drawInfoColumns(pdfComponents, dataHead);
  drawTable(tableComponents);
};

const generateDispatchSttFailed = (props: DispatchSttFailedProps) => {
  const { doc, sttData, logo } = props;
  doc.addPage("a4", "p");

  const data = sttData.stts.map((e, index) => ({
    no: index + 1,
    ddSttNo: e.ddSttNo || "-",
    ddRefNo: e.ddRefNo || "-",
    ddProductType: e.ddProductType || "-",
    ddDemNo: e.ddDemNo || "-",
    ddPieces: e.ddPieces || "-",
    ddDestinationUrsaCode: e.ddDestinationUrsaCode || "-",
    ddScanStatus: getScanStatusText(e.ddScanStatus, e.ddLastStatus),
  }));

  failedDispatchPDF({
    doc,
    dataHead: sttData,
    data,
    logo,
  });
};

export default generateDispatchSttFailed;
